import { Checkbox } from '@material-ui/core'
import PinDropOutlinedIcon from '@material-ui/icons/PinDropOutlined'

import { FieldInfo } from '@/pages/maps/contexts/region-context'

import { useStyles } from './styles'

interface FieldListItemProps {
  field: FieldInfo & { checked: boolean }
  onToggle?: (id: string) => void
  onGoToField: (id: string) => void
}

export default function FieldListItem({
  field,
  onToggle,
  onGoToField,
}: FieldListItemProps) {
  const classes = useStyles()

  const handleToggle = () => {
    onToggle?.(field.id)
  }

  const handleGoToField = () => {
    onGoToField(field.id)
  }

  return (
    <div className={classes.fieldItem}>
      <div className={classes.fieldName}>
        <Checkbox
          checked={field.checked}
          onChange={handleToggle}
          size='small'
        />
        <span title={field.field_name} className={classes.fieldNameText}>
          {field.field_name}
        </span>
      </div>
      <span className={classes.areaTag}>{field.area} ha</span>
      <span className={classes.diagnosisTag}>{field.diagnoses_count}</span>
      <div className={classes.iconContainer}>
        <PinDropOutlinedIcon
          aria-label='ícone de localização'
          fontSize='small'
          style={{ cursor: 'pointer' }}
          onClick={handleGoToField}
        />
      </div>
    </div>
  )
}
